import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { ReservationErrorPane } from '../../molecules/reservations/ReservationErrorPane';
import { useEventReservationState } from './states/EventPaneState';
import { routingStore } from '../../../../common/stores/routing';

type Props = {
  eventId: number;
};

export const EventReservationError = observer((props: Props) => {
  const { event, errorMessage } = useEventReservationState(props.eventId);
  if (event.isNotFound()) {
    return <NotFoundPage entityType="イベント" />;
  }
  if (event.loading) {
    return <GlobalLoader />;
  }
  return (
    <ReservationErrorPane
      message={errorMessage || ''}
      onCompleteClick={() => GlobalStatesV3.routing.push(V3Routes.DynamicPath.closeEventOverlay(routingStore.location))}
    />
  );
});
